import React from 'react';
import LoadingBlock from "../../components/loader/LoadingBlock";
import {useGetAndFetchToken} from "../../hooks/useGetAndFetchToken";

interface PermissionProviderProps {
    children?: React.ReactNode
}

const Auth0Provider: React.FC<PermissionProviderProps> = ({children}) => {
    const {loading} = useGetAndFetchToken()
    if (loading) {
        return <LoadingBlock/>
    }

    return (
        <>
            {children}
        </>
    );
}

export default Auth0Provider;